import { VehicleInfo } from "../../types/vehicle.type";
import './vehicleCard.scss';

type Props = VehicleInfo & {
    expandMetrics: boolean;
    onMoreInfoClick?: () => void;
    onClickVehicleCard?: () => void;
    hideMoreInfoButton?: boolean;
};

const VehicleCard: React.FC<Props> = ({ vehicleBasicInfo, expandMetrics, onMoreInfoClick, onClickVehicleCard, hideMoreInfoButton }) => {
    const {
        vehicle,
        deviceId,
        licensePlate,
        status,
        location,
        timestamp,
        imageUrl,
        metrics
    } = vehicleBasicInfo;

    return (
        <section className="vehicle-card" onClick={onClickVehicleCard}>

            <header className="pic-n-details">
                <figure className="vehicle-pic">
                    <img src={imageUrl} alt={vehicle} width="100" height="60" />
                </figure>
                <ul className="vehicle-details">
                    <li>{vehicle}</li>
                    <li>Device ID - {deviceId}</li>
                    <li>License Plate No. - {licensePlate}</li>
                </ul>
            </header>

            <article className="status-n-location">
                <div className={`status ${status.toLowerCase()}_status`}>
                    <i></i> <span>{status}</span>
                </div>
                <aside className="location">
                    <i></i> <span>{location}</span>
                </aside>
            </article>

            {
                expandMetrics && (
                    <ol className="metrics">
                        <li><h3>{metrics.speed}</h3><h4>Speed</h4></li>
                        <li><h3>{metrics.fuelRate}</h3><h4>Fuel Rate</h4></li>
                        <li><h3>{metrics.mileage}</h3><h4>Mileage</h4></li>
                        <li><h3>{metrics.temperature}</h3><h4>Temperature</h4></li>
                        <li><h3>{metrics.pressure}</h3><h4>Pressure</h4></li>
                        <li><h3>{metrics.vibration}</h3><h4>Vibration</h4></li>
                    </ol>
                )

            }

            <footer className="time-n-action">
                <time>{(new Date(timestamp)).toDateString()}</time>
                {
                    expandMetrics && !hideMoreInfoButton && (
                        <button onClick={onMoreInfoClick}>More info</button>
                    )
                }
            </footer>

        </section>
    );
}

export default VehicleCard;